module.exports = __webpack_public_path__ + "img/1450048486.1302fdd0.jpg";